import * as React from "react";
const BorderDashedSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 9H4V8h3v1Zm4 0H8V8h3v1Zm1 0h2V8h-2v1Z" }));
BorderDashedSmall.displayName = "BorderDashedSmall";
var BorderDashedSmall_default = BorderDashedSmall;
export {
  BorderDashedSmall_default as default
};
